const linkResolver = require('./link-resolver')

exports.linkResolver = linkResolver